import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import navegacao from './navegacao'
import {storeModule as auth} from '@/velta/components/auth';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        appConfig,
        verticalMenu,
        navegacao,
        auth,
    },
    strict: false,
})
